"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
var _hikeAdvancedReport = require("@/api/hike-advanced-report");
var _log = require("@/utils/log");
var _hike = require("@/api/hike");
var _cookie = require("@/utils/cookie");
var _lodash = _interopRequireDefault(require("lodash"));
var _moment = _interopRequireDefault(require("moment"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const tmpHikeAdvReportInfo = {};
const tmpArray = [];
var _default = exports.default = {
  name: 'HikeAdvReportAdvancedReport',
  components: {},
  props: {
    parentId: {
      type: String,
      default: tmpHikeAdvReportInfo
    },
    parentReports: {
      type: Array,
      default: tmpArray
    }
  },
  filters: {
    getInternalTitle(value) {
      // console.log('row value', value)
      return typeof value === 'undefined' ? '' : value.title;
    }
  },
  data() {
    return {
      showWarning: false,
      showStageWarning: false,
      showPiWarning: false,
      customToolbar: [['bold', 'italic', 'underline'], [{
        list: 'ordered'
      }, {
        list: 'bullet'
      }], [{
        color: []
      }, {
        background: []
      }], ['clean']],
      loading: false,
      hikeParticipants: {},
      reports: [],
      reportId: '',
      removeHikeDialogVisible: false,
      removeHikeIndex: -1,
      removeHikeText: '',
      addHikeDialogVisible: false,
      addHikeLoading: false,
      hikeSelected: false,
      hikeTotal: 0,
      hikeList: [],
      hikeQuery: {
        page: 1,
        limit: 10,
        sort: '-start.utc',
        q: undefined,
        publish: undefined,
        staffUuid: undefined,
        staffRole: undefined
      },
      addParticipantLoading: false,
      participantList: [],
      participantSelectedUuids: {},
      editHikeDialogVisible: false,
      editParticipantLoading: false,
      editHikeDialogIndex: -1,
      editHikeDialogHikeId: '',
      editHikeTitle: ''
    };
  },
  watch: {
    reports: {
      handler(newVal) {
        this.passBackReport(newVal);
      },
      deep: true
    }
  },
  created() {
    this.reportId = this.parentId;
    this.reports = _lodash.default.cloneDeep(this.parentReports);
    this.getReportHikeParticipantsDetails();
  },
  methods: {
    getHikeTitle(hikeId) {
      const hike = this.hikeParticipants['hikes'][hikeId];
      return hike ? hike['title'] ? hike['title'] : '' : '';
    },
    getHikeInternal(hikeId, key) {
      const hike = this.hikeParticipants['hikes'][hikeId];
      return hike ? hike['internal'] ? hike['internal'][key] ? hike['internal'][key] : '' : '' : '';
    },
    getParticipantName(uuid) {
      const p = this.hikeParticipants['participants'][uuid];
      return p['givenName'] + ' ' + p['familyName'];
    },
    getParticipantAvatar(uuid) {
      const p = this.hikeParticipants['participants'][uuid];
      return p['profilePic'];
    },
    resetAll() {
      this.addHikeDialogVisible = false;
      this.addHikeDialogLoading = false;
      this.hikeSelected = {};
      this.participantSelectedUuids = {};
      this.participantList = [];
      this.editHikeDialogVisible = false;
      this.editParticipantLoading = false;
      this.editHikeDialogIndex = -1;
      this.editHikeDialogHikeId = '';
      this.editHikeTitle = '';
      this.removeHikeDialogVisible = false;
      this.removeHikeText = '';
    },
    reportHikeAdd() {
      this.resetAll();
      this.addHikeDialogVisible = true;
      this.addHikeDialogLoading = true;
      this.loadHikeList();
    },
    reportHikeEdit(index, hikeId) {
      this.resetAll();
      this.editHikeDialogVisible = true;
      this.editHikeDialogLoading = true;
      this.editHikeDialogIndex = index;
      this.editHikeDialogHikeId = hikeId;
      this.editHikeTitle = this.getHikeTitle(hikeId);

      // Put current selected UUID
      const report = this.reports[this.editHikeDialogIndex];
      for (const p of report['participants']) {
        this.participantSelectedUuids[p] = 'good';
      }
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.editParticipantLoading = true;
      (0, _hike.getParticipant)(token, hikeId).then(response => {
        this.editParticipantLoading = false;
        this.participantList = response.data.rows;
      }).catch(error => {
        this.editParticipantLoading = false;
        (0, _log.showDebugLog)('Hike-getParticipant-API-error', error);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    reportHikeDelete(index, title) {
      this.removeHikeDialogVisible = true;
      this.removeHikeIndex = index;
      this.removeHikeText = title;
    },
    doReportHikeDelete() {
      this.removeHikeDialogVisible = false;
      this.removeHikeText = '';
      if (this.removeHikeIndex < this.reports.length) {
        this.reports.splice(this.removeHikeIndex, 1);
        this.getReportHikeParticipantsDetails();
        this.resetAll();
      }
    },
    getReportHikeParticipantsDetails() {
      this.loading = true;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      (0, _hikeAdvancedReport.getAdvancedReportHikeParticipants)(token, {
        'reports': this.reports
      }).then(response => {
        this.loading = false;
        this.hikeParticipants = response.data;
        this.showWarning = false;
        this.showStageWarning = false;
        this.showPiWarning = false;
        const warnings = this.hikeParticipants['warnings'];
        if (warnings['stage'] === 'warning') {
          this.showStageWarning = true;
        }
        if (warnings['skill'] === 'warning') {
          this.showPiWarning = true;
        }
        if (this.showStageWarning || this.showPiWarning) {
          this.showWarning = true;
        }
      }).catch(error => {
        (0, _log.showDebugLog)('hike-getHikeById-error', error);
        this.loading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    passBackReport(report) {
      this.$emit('updateParentReports', report);
    },
    loadHikeList() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.addHikeLoading = true;
      (0, _hike.getHikeList)(token, this.hikeQuery).then(response => {
        (0, _log.showDebugLog)('Hike-Search-response', response);
        this.hikeList = response.data.rows;
        this.hikeTotal = response.data.count;
        this.addHikeLoading = false;
      }).catch(error => {
        (0, _log.showDebugLog)('hike-Search-error', error);
        this.addHikeDialogLoading = false;
        (0, _log.displayPopupMessage)(error, 'error');
        // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response })
      });
    },
    isHikeListExipred(endUtc) {
      var now = _moment.default.utc();
      var end = _moment.default.utc(endUtc);
      return now > end;
    },
    handleHikeListCurrentChange(val) {
      this.hikeQuery.page = val;
      this.loadHikeList();
    },
    handleHikeListSizeChange(val) {
      this.hikeQuery.limit = val;
      this.loadHikeList();
    },
    handleHikeListSelectionChange(val) {
      this.hikeSelected = val;
      this.participantList = [];
      this.participantSelectedUuids = {};
      this.loadHikeParticipants();
    },
    searchHikeList(pageNo) {
      this.hikeQuery.page = pageNo;
      this.hikeQuery.q = this.hikeQuery.q === '' ? undefined : this.hikeQuery.q;
      this.hikeQuery.publish = this.hikeQuery.publish === '' ? undefined : this.hikeQuery.publish;
      this.loadHikeList();
    },
    loadHikeParticipants() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const hikeId = this.hikeSelected['id'];
      this.addParticipantLoading = true;
      (0, _hike.getParticipant)(token, hikeId).then(response => {
        this.addParticipantLoading = false;
        this.participantList = response.data.rows;
      }).catch(error => {
        this.addParticipantLoading = false;
        (0, _log.showDebugLog)('Hike-getParticipant-API-error', error);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    participantSelected(p) {
      if (this.participantSelectedUuids[p['uuid']]) {
        this.$delete(this.participantSelectedUuids, p['uuid']);
      } else {
        this.$set(this.participantSelectedUuids, p['uuid'], 'good');
      }
    },
    doAddHikeParticipant() {
      this.reports.push({
        'hike': this.hikeSelected['id'],
        'participants': Object.keys(this.participantSelectedUuids)
      });
      this.resetAll();
      this.getReportHikeParticipantsDetails();
    },
    doEditHikeParticipant() {
      if (this.editHikeDialogIndex > -1 && this.editHikeDialogIndex < this.reports.length) {
        this.reports[this.editHikeDialogIndex] = {
          'hike': this.editHikeDialogHikeId,
          'participants': Object.keys(this.participantSelectedUuids)
        };
      }
      this.resetAll();
      this.getReportHikeParticipantsDetails();
    }
  }
};